// src/components/icons/recordingModeIcons.js
//
// Recording-mode glyphs, ported from the patient web app so the dashboard shows
// the same icon a patient sees on each recording-mode button. Material Symbols
// paths (viewBox 0 -960 960 960); `fill="currentColor"` lets the colour be set
// by the parent (e.g. text-primary on the badge).
import * as React from "react";
import DirectionsWalk from "@mui/icons-material/DirectionsWalk";

export { FramePersonIcon } from "./FramePersonIcon";

export const SpirometryIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
    {...props}
  >
    <path d="M200-120q-51 0-85.5-34.5T80-240v-167l105-281q12-33 42-52.5t65-19.5q45 0 76.5 32.5T400-649v49h-80v-49q0-13-9-22t-21-9q-10 0-18.5 5.5T260-660L160-392v152q0 17 11.5 28.5T200-200h120q17 0 28.5-11.5T360-240v-80h80v80q0 51-35 85.5T320-120zm559 0H639q-50 0-85-34.5T519-240v-80h80v80q0 17 11.5 28.5T639-200h120q17 0 28.5-11.5T799-240v-152L699-660q-4-9-12-14.5t-18-5.5q-13 0-21.5 9t-8.5 22v49h-80v-49q0-46 31.5-78.5T667-760q35 0 64.5 19.5T774-688l105 281v167q0 51-35 85.5T759-120M480-503 376-400l-56-56 120-120v-304h80v304l120 120-57 56z" />
  </svg>
);

export const CardiopulmonaryIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
    {...props}
  >
    <path d="m574-256 66-67v-37 37zm212 0-66-67v-37 37zM80-600v-120q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v220h-80v-220H160v120zm80 440q-33 0-56.5-23.5T80-240v-120h80v120h220v80zm120-120q-11 0-21-5.5T244-302l-69-138H80v-80h120q11 0 21 5.5t15 16.5l44 88 124-248q5-10 15-15t21-5 21 5 15 15l79 159q-21 2-39.5 9T481-470l-41-80-124 248q-5 11-15 16.5t-21 5.5M500-40q-25 0-42.5-17.5T440-100v-147l53-141q9-23 29.5-37.5T568-440h72v-80h80v80h72q25 0 45.5 14.5T867-388l53 141v147q0 25-17.5 42.5T860-40h-80q-25 0-42.5-17.5T720-100v-60h80v40h40v-113l-48-127h-72v37l66 67-56 56-50-50-50 50-56-56 66-67v-37h-72l-48 127v113h40v-40h80v60q0 25-17.5 42.5T580-40zm180-200" />
  </svg>
);

export const PulseScanIcon = ({ className = "", style, ...props }) => (
  <span
    aria-hidden="true"
    className={[
      "material-symbols-outlined",
      "inline-flex items-center justify-center overflow-hidden align-middle leading-none",
      className,
    ]
      .filter(Boolean)
      .join(" ")}
    style={{
      fontSize: "16px",
      width: "1em",
      height: "1em",
      ...style,
    }}
    {...props}
  >
    ecg
  </span>
);

export const ExertionRecoveryIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
    {...props}
  >
    <path d="m140-100-60-60 300-300 160 160 284-320 56 56-340 384-160-160zm0-240-60-60 300-300 160 160 284-320 56 56-340 384-160-160z" />
  </svg>
);

export const ManualAudioIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 -960 960 960"
    fill="currentColor"
    {...props}
  >
    <path d="M80-80v-80q46 0 91-6t88-22q-46-23-72.5-66.5T160-349v-91h160v-120h135L324-822l72-36 131 262q20 40-3 78t-68 38h-56v40q0 33-23.5 56.5T320-360h-80v11q0 35 21.5 61.5T316-252l12 3q40 10 45 50t-31 60q-60 33-126.5 46T80-80m572-114-57-56q21-21 33-48.5t12-59.5-12-59.5-33-48.5l57-57q32 32 50 74.5t18 90.5-18 90-50 74M765-80l-57-57q43-43 67.5-99.5T800-358q0-66-24.5-122T708-579l57-57q54 54 84.5 125T880-358q0 81-30.5 152.5T765-80" />
  </svg>
);

export const SixMinuteWalkIcon = ({ className = "", style, ...props }) => (
  <DirectionsWalk
    className={className}
    style={{
      fontSize: "14px",
      width: "1em",
      height: "1em",
      ...style,
    }}
    {...props}
  />
);
